import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

import './Exams.css'
import { fetchEditUserExam, fetchExam, fetchUserExam } from './ExamApi';
import { fetchTriggerExport } from '../ExportsScreen/ExportsApi';
import { setLoading } from '../../services/global/globalSlice';
import ReactPlayer from 'react-player';
import { Tab, Tabs } from 'react-bootstrap';

import arrow_back_img from '../../assets/images/arrow-back.svg'
import download_img from '../../assets/images/download.svg'

import { use } from 'react';
import ConfirmModal from '../../components/_modals/ConfirmModal';
import { toast } from 'react-toastify';
import { DEFAULT_FIELDS, USER_EXAM_STATUS } from '../../config/constants';
import { selectUserFields } from '../../features/User/userSlice';
import { fetchUser } from '../UsersScreen/UsersApi';

import UserExamActionModal from './_components/UserExamActionModal';

export default function UserExamDetails(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [examData, setExamData] = useState({})
    const [userData, setUserData] = useState({})
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })
    const [actionModal, setActionModal] = useState({
        type: 'note',
        show: false,
        onClose: (e)=>handleCloseActionModal(e),
        onConfirm: (e)=>handleCloseActionModal(e),
    })

    const {exam_id, user_exam_id} = useParams()
    const userFields = useSelector(selectUserFields)

    const loadUserData = async (user_id) => {
        dispatch(setLoading(true))
        const response = await fetchUser(user_id)
        if(response.success){
            setUserData(response.data)
            dispatch(setLoading(false))
        } else {
            dispatch(setLoading(false))
        }
    }

    const loadUserExamData = async ( ) => {
        const response =  await fetchUserExam(user_exam_id)
        if(response.success){
            setExamData(response.data)
            if(response?.data?.user_data?.user_id)
                loadUserData(response?.data?.user_data?.user_id)
            else
                dispatch(setLoading(false))
        } else {
            console.error("error")
            dispatch(setLoading(false))
        }
    }

    const openResetmodal = () => {
        if(user_exam_id){
            setConfirmModal({
                    ...confirmModal,
                    show:true,
                    title: t.exam.delete_user_exam,
                    text: t.exam.delete_user_exam_text,
                    onClose: ()=>closeConfirmModal(),
                    onConfirm: ()=>handleDeleteUserExam(user_exam_id),
                    confirmCta: t.modals.confirm,
                    closeCta: t.modals.close
                })
            }
    }

    const openResumemodal = () => {
        if(user_exam_id){
            setConfirmModal({
                    ...confirmModal,
                    show:true,
                    title: t.exam.allow_resume_user_exam,
                    text: t.exam.allow_resume_user_exam_text,
                    onClose: ()=>closeConfirmModal(),
                    onConfirm: ()=>handleAllowResumeUserExam(user_exam_id),
                    confirmCta: t.modals.confirm,
                    closeCta: t.modals.close
                })
            }
    }

    const openBypassProctoringModal = () => {
        if(user_exam_id){
            setConfirmModal({
                    ...confirmModal,
                    show:true,
                    title: t.exam.bypass_proctoring_user_exam,
                    text: t.exam.bypass_proctoring_user_exam_text,
                    onClose: ()=>closeConfirmModal(),
                    onConfirm: ()=>handleBypassProctoringUserExam(user_exam_id),
                    confirmCta: t.modals.confirm,
                    closeCta: t.modals.close
                })
            }
    }

    const closeConfirmModal = () => {
        setConfirmModal({
        ...confirmModal,
        show: false,
        onConfirm: null
        })
    }

    const handleDeleteUserExam = async (user_exam_id) => {
        if(user_exam_id){
        try {
            // Sostituisci con il tuo endpoint API
            const response = await fetchEditUserExam(user_exam_id,{
                deleted: true,
                admin_exam_resume_authorized: examData?.admin_exam_resume_authorized
            })
            if(response.success){
                closeConfirmModal()
                toast.success("Tentativo eliminato")
            }
        } catch (error) {
            toast.error(`Errore durante il recupero dei dati ${error}`)
            return null;
        }
        }
    }

    const handleAllowResumeUserExam = async (user_exam_id) => {
        if(user_exam_id){
        try {
            // Sostituisci con il tuo endpoint API
            const response = await fetchEditUserExam(user_exam_id,{
                deleted: examData?.deleted,
                admin_exam_resume_authorized: true
            })
            if(response.success){
                closeConfirmModal()
                toast.success("Tentativo eliminato")
            }
        } catch (error) {
            toast.error(`Errore durante il recupero dei dati ${error}`)
            return null;
        }
        }
    }

    const handleBypassProctoringUserExam = async (user_exam_id) => {
        if(user_exam_id){
        try {
            const response = await fetchEditUserExam(user_exam_id,{
                deleted: examData?.deleted,
                admin_exam_resume_authorized: examData?.admin_exam_resume_authorized,
                bypass_proctoring: true
            })
            if(response.success){
                closeConfirmModal()
                toast.success("Proctoring bypassato")
                loadUserExamData()
            }
        } catch (error) {
            toast.error(`Errore durante il recupero dei dati ${error}`)
            return null;
        }
        }
    }

    const handleExportSingleResult = async () => {
        dispatch(setLoading(true))
        const response = await fetchTriggerExport('exam', 'csv', { exam_id: [exam_id], user_id: [examData?.user_data?.user_id] })
        if(response.success){
            toast.success(t.exports.export_triggered)
        } else {
            toast.error(t.error.error_loading)
        }
        dispatch(setLoading(false))
    }

    const openActionModal = (action) => {
        setActionModal({
            ...actionModal,
            show: true,
            type: action
        })
    }

    const handleCloseActionModal = (reload = false) => {
        setActionModal({
            ...actionModal,
            show: false
        })
        console.log(reload);
        if(reload)
            loadUserExamData()
    }

    useEffect(()=>{
        if(exam_id && user_exam_id){
            dispatch(setLoading(true))
            loadUserExamData()
        } else {
            navigate('/exams',{replace:true})
        }
    },[])

    return (
        <section id="examsScreen">
            <Link to={`/exams/user_exams/${exam_id}`}>
                <img src={arrow_back_img} alt='' style={{verticalAlign:'middle'}}/>
                <span>{t.buttons.back}</span>
            </Link>
            {
                examData &&
                <div className='mt-2'>
                    <h3 className='text-tf'>{examData?.exam_title}</h3>
                    <h2 className='mb-2'>{t.user_exam.title} <u>{examData?.user_data?.firstname} {examData?.user_data?.lastname}</u></h2>
                    <hr />
                    
                    <Tabs
                        defaultActiveKey="attempt"
                        className="mt-3 mb-4"
                    >
                        <Tab eventKey="attempt" title={t.user_exam.tabs.exam_details}>
                            <div className='row align-items-start'>
                                <div className='col-6'>
                                    <table className='info_table'>
                                        <tr>
                                            <th colSpan={2} className='text-center'>
                                                Dettagli Candidato
                                            </th>
                                        </tr>
                                        <tr>
                                            <td><strong>ID</strong></td>
                                            <td>{examData?.user_data?.user_id}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t.exam_details.candidate}</strong></td>
                                            <td>{examData?.user_data?.firstname} {examData?.user_data?.lastname}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>E-Mail</strong></td>
                                            <td>{examData?.user_data?.email}</td>
                                        </tr>
                                        {
                                            userFields?.map((f)=>{
                                                const field_id = f.field_id
                                                if(!DEFAULT_FIELDS.includes(field_id)){
                                                    return(
                                                        <tr key={field_id}>
                                                            <td><strong>{f.field_names['it']}</strong></td>
                                                            <td>{userData?.extra_fields?.find(e => e.field_id === field_id)?.values || ''}</td>
                                                        </tr>
                                                    )
                                                } else {
                                                    return null
                                                }}) 
                                        }
                                    </table>
                                </div>
                                <div className='col-6'>
                                    
                                    <table className='info_table'>
                                        <tr>
                                            <th colSpan={2} className='text-center'>
                                                Dettagli Prova
                                            </th>
                                        </tr>
                                        <tr>
                                            <td><strong>ID</strong></td>
                                            <td>{examData?.user_exam_id}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t.exam_details.status}</strong></td>
                                            <td>
                                                {!examData?.deleted ?
                                                    <span className='status_label' style={{color:`${USER_EXAM_STATUS[examData?.state]?.color}`, background: `${USER_EXAM_STATUS[examData?.state]?.background}`}}>{USER_EXAM_STATUS[examData?.state]?.text}</span> 
                                                :
                                                    <span className='status_label' style={{color:`${USER_EXAM_STATUS['deleted']?.color}`, background: `${USER_EXAM_STATUS['deleted']?.background}`}}>{USER_EXAM_STATUS['deleted']?.text}</span> 
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Data-Ora Fine</strong></td>
                                            <td>{new Date(examData?.start_date)?.toLocaleString()}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Data-Ora Fine</strong></td>
                                            <td>{new Date(examData?.end_date)?.toLocaleString()}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Punteggio totale</strong></td>
                                            <td>{examData?.total_score}</td>
                                        </tr>
                                    </table>
                                    <div className='d-flex justify-content-end mt-3'>
                                        <button className='btn btn-outline-secondary me-2' onClick={handleExportSingleResult}>
                                            <img src={download_img} alt='' style={{verticalAlign:'middle'}} className='me-1'/>
                                            {t.exports.export_this_result}
                                        </button>
                                        {
                                            examData?.certificate_pdf_url &&
                                                <a className='btn btn-outline-secondary me-2' href={examData?.certificate_pdf_url} target='_blank' rel='noreferrer' download>
                                                    <img src={download_img} alt='' style={{verticalAlign:'middle'}} className='me-1'/>
                                                    {t.exam_details.download_result}
                                                </a>
                                        }
                                        {
                                            !examData?.deleted &&
                                                <button className='btn btn-danger' onClick={openResetmodal}>{t.exam_details.reset}</button>
                                        }
                                        {
                                            (examData?.state === "in_progress") &&
                                                <button className='btn btn-warning ms-2' onClick={openResumemodal}>{t.exam_details.resume}</button>
                                        }
                                        {
                                            !examData?.deleted && !examData?.bypass_proctoring &&
                                                <button className='btn btn-secondary ms-2' onClick={openBypassProctoringModal}>{t.exam_details.bypass_proctoring}</button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-12'>
                                    <table className='info_table'>
                                        <thead>
                                            <tr>
                                                <th className='text-center' colSpan={3}>Soglie di punteggio</th>
                                            </tr>
                                            <tr>
                                                <th>Soglia</th>
                                                <th>Punteggio</th>
                                                <th>Esito</th>
                                            </tr>
                                        </thead>
                                        {
                                            examData?.thresholds?.map((t,index)=>{
                                                return(
                                                    <tr key={index}>
                                                        <td><strong>{t.threshold_name}</strong></td>
                                                        <td>{t?.score}</td>
                                                        <td>{t?.has_been_passed ? "Passed": 'Not Passed'}</td>
                                                    </tr>  
                                                )
                                            })
                                        }
                                    </table>
                                </div>
                            </div>
                            
                        </Tab>
                        {
                            examData?.proctoring_review_data &&
                                <Tab eventKey="proctoring" title={t.user_exam.tabs.proctoring}>
                                    <div className='d-flex align-items-center justify-content-end'>
                                        <button onClick={()=>{openActionModal('note')}}>
                                            Aggiugni nota
                                        </button>
                                        <button className='btn btn-success ms-2' onClick={()=>{openActionModal('approve')}}>
                                            Approva Tentativo
                                        </button>
                                        <button className='btn btn-danger ms-2' onClick={()=>{openActionModal('reject')}}>
                                            Rifiuta tentativo
                                        </button>
                                    </div>
                                    {
                                        examData?.admin_notes?.length > 0 &&
                                            <div className='row mt-3 px-4 border border-2 border-warning'>
                                                <h5 className='mt-2'>Note:</h5>
                                                <ul>
                                                    {
                                                        examData?.admin_notes?.map((note,key)=>{
                                                            return(
                                                                <li key={key}>{note}</li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                    }
                                    <div className='row mt-3'>
                                        <div className='col-4'>
                                            <p>Immagine identificativa candidato:</p>
                                            <img src={examData?.proctoring_review_data?.loginPhoto} />
                                        </div>
                                        <div className='col-4'>
                                            <p>Documento d'identità:</p>
                                            <img src={examData?.proctoring_review_data?.loginIDImage} />
                                        </div>
                                        <div className='col-4'>
                                            <div className='group'>
                                                <label>Punteggio di affidabilità:</label>
                                                <h3>{examData?.proctoring_review_data?.fairnessScore}% </h3>
                                            </div>
                                            <div className='group'>
                                                <label>Orario di accesso:</label>
                                                <p>{new Date(examData?.proctoring_review_data?.loginTime)?.toLocaleString()} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-4'>  
                                        <div className='col-6'>
                                            <p>Registrazione candidato:</p>
                                            <Tabs
                                                defaultActiveKey="screen_0"
                                                className="mt-3 mb-4"
                                            >
                                                {
                                                    examData?.proctoring_review_data?.recording?.filter(r => r.type === 'Candidate')?.map((r,index)=>{
                                                        return(
                                                            <Tab eventKey={`screen_${index}`} title={`Video ${index+1}`}>
                                                                <div className="video-player">
                                                                    <ReactPlayer
                                                                        url={r?.video}
                                                                        controls
                                                                        width="100%"
                                                                        height="100%"
                                                                        onDuration={(e)=>{console.log(e)}} // get total duration once loaded
                                                                        config={{
                                                                            file: {
                                                                                attributes: {
                                                                                    preload: "metadata", // fast duration
                                                                                    playsInline: true    // iOS inline playback
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                    
                                                                </div>
                                                            </Tab>
                                                        )
                                                    })

                                                }

                                            </Tabs>
                                        </div>
                                        <div className='col-6'>
                                            <p>Registrazione schermo:</p>
                                            <Tabs
                                                defaultActiveKey="screen_0"
                                                className="mt-3 mb-4"
                                            >
                                                {
                                                    examData?.proctoring_review_data?.recording?.filter(r => r.type === 'Screen')?.map((r,index)=>{
                                                        return(
                                                            <Tab eventKey={`screen_${index}`} title={`Video ${index+1}`}>
                                                                <div className="video-player">
                                                                    <ReactPlayer
                                                                        url={r?.video}
                                                                        controls
                                                                        width="100%"
                                                                        height="100%"
                                                                    />
                                                                </div>
                                                            </Tab>
                                                        )
                                                    })

                                                }

                                            </Tabs>
                                        </div>
                                    </div>
                                    <div className='row mt-4'>
                                        <div className='col-12'>
                                            <table className='info_table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-center' colSpan={5}>Violazioni</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Data/Ora</th>
                                                        <th>Tipologia</th>
                                                        <th>Immagine</th>
                                                        <th>Livello</th>
                                                        <th>Peso</th>
                                                    </tr>
                                                </thead>
                                                {
                                                    examData?.proctoring_review_data?.violations?.map((v,index)=>{
                                                        return(
                                                            <tr key={index}>
                                                                <td><strong>{new Date(v?.timestamp)?.toLocaleString()}</strong></td>
                                                                <td>{v?.message}</td>
                                                                <td><img src={v?.evidenceURL} /></td>
                                                                <td>{v?.violationlevel}</td>
                                                                <td>{v?.weightage}</td>
                                                            </tr>  
                                                        )
                                                    })
                                                }
                                            </table>
                                        </div>
                                    </div>
                        
                                </Tab>
                        }
                    </Tabs>
                    
                </div>
            }
           <ConfirmModal props={confirmModal} /> 
           <UserExamActionModal props={actionModal} user_exam_id={user_exam_id} />
        </section>
    )
}